import React from 'react';
import { connect } from 'react-redux';
import { hot } from 'react-hot-loader';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@adaguc/react-webmapjs/dist/main.css';
import style from './styles/main.css'; // eslint-disable-line no-unused-vars
import Header from './Header';
import Menu from './Menu';
import Content from './Content';
import FooterContainer from './FooterContainer';
require('./img/adaguc-logo-favicon-16x16.png');
require('./img/adaguc-logo-favicon-32x32.png');

const App = () => {
  return (<div className='wrapper'>
    <div className='header'><Header /></div>
    <div className='menu'><Menu /></div>
    <div className='sidebar'>Sidebar</div>
    <div className='content'><Content /></div>
    <div className='footer'><FooterContainer /></div>
  </div>);
};
export default hot(module)(connect(null)(App));
